export enum ProjectStatusCode {
    DRAFT = 'DRF',
    SENT = 'SND'
}
